/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateIpDeviceRequest} from "../model/create-ip-device-request";
import {DeleteRequest} from "../model/delete-request";
import {IpDeviceResponse} from "../model/ip-device-response";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {UpdateIpDeviceRequest} from "../model/update-ip-device-request";

@Injectable({
    providedIn: "root",
})
export class SimIpDeviceService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createIpDevice(request: CreateIpDeviceRequest) {
        return super.post<SuccessCreateResponse>(`/api/IpDevice/CreateIpDevice`, request);
    }

    public deleteIpDevice(request: DeleteRequest) {
        return super.post<SuccessResponse>(`/api/IpDevice/DeleteIpDevice`, request);
    }

    public getIpDeviceById(ipDeviceId: string) {
        return super.get<IpDeviceResponse>(`/api/IpDevice/GetIpDeviceById`, {ipDeviceId: ipDeviceId});
    }

    public getIpDevices() {
        return super.get<IpDeviceResponse[]>(`/api/IpDevice/GetIpDevices`, );
    }

    public updateIpDevice(request: UpdateIpDeviceRequest) {
        return super.post<SuccessResponse>(`/api/IpDevice/UpdateIpDevice`, request);
    }
}